import { render, staticRenderFns } from "./HistoricPersonalDoctorsNetworkError.vue?vue&type=template&id=c56b2dc6"
import script from "./HistoricPersonalDoctorsNetworkError.vue?vue&type=script&lang=js"
export * from "./HistoricPersonalDoctorsNetworkError.vue?vue&type=script&lang=js"
import style0 from "./HistoricPersonalDoctorsNetworkError.vue?vue&type=style&index=0&id=c56b2dc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports